module.exports = __webpack_public_path__ + "img/spinner.39fb8dc6.svg";